<template>
  <div class="group-read-only form-group form-group--group">
    <div class="panel panel-default">
      <div
        v-if="!component.hideLabel"
        class="panel-heading"
      >
        <h4
          v-if="!component.hideLabel"
          class="panel-title"
        >{{ component.label }}</h4>
      </div>
      <div class="panel-body">
        <template
          v-for="(component, index) in component.components"
          :index="index"
        >
          <component
            :is="`${component.type}-read-only`"
            v-show="!$checkConditionalViewAllow(component, components, variables, json)"
            :key="component._uuid"
            :component="component"
            :components="components"
            :value="jsonData[component.key]"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
// https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
import { mapState } from 'vuex'

// Components
import TextReadOnly from '@/components/text/TextReadOnly.vue'
import PasswordReadOnly from '@/components/password/PasswordReadOnly.vue'
import NumberReadOnly from '@/components/number/NumberReadOnly.vue'
import SelectReadOnly from '@/components/select/SelectReadOnly.vue'
import SelectApiReadOnly from '@/components/select-api/SelectApiReadOnly.vue'
import SelectResourceReadOnly from '@/components/select-resource/SelectResourceReadOnly.vue'
import TextareaReadOnly from '@/components/textarea/TextAreaReadOnly.vue'
import CheckboxSingleReadOnly from '@/components/checkbox-single/CheckboxSingleReadOnly.vue'
import CheckboxReadOnly from '@/components/checkbox/CheckboxReadOnly.vue'
import RadioReadOnly from '@/components/radio/RadioReadOnly.vue'
import FileReadOnly from '@/components/file/FileReadOnly.vue'
import DatepickerReadOnly from '@/components/datepicker/DatepickerReadOnly.vue'
import HelpBlockReadOnly from '@/components/help-block/HelpBlockReadOnly.vue'

export default {
  props: ['component', 'components'],
  components: {
    TextReadOnly,
    PasswordReadOnly,
    NumberReadOnly,
    SelectReadOnly,
    SelectApiReadOnly,
    SelectResourceReadOnly,
    TextareaReadOnly,
    CheckboxSingleReadOnly,
    CheckboxReadOnly,
    RadioReadOnly,
    FileReadOnly,
    DatepickerReadOnly,
    HelpBlockReadOnly
  },
  name: 'GroupReadOnly',
  computed: {
    // The mapState Helper
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState({
      formDataIdBind: state => state.formDataId.data,
      formJson: state => state.formJson,
      variables: state => state.config.variables,
      json: state => state.config.json
    }),
    jsonData () {
      return this.formDataIdBind || this.json
    }
  }
}
</script>
